import React from 'react';
import { Portal } from '../../components';
import AlertTabs from './alert-tabs/alert-tabs';

import './exceptions-management.scss';

const ExceptionsManagementPortal = props => {
	return <Portal element={<AlertTabs {...props} />} nodeId="exceptions-portal" />;
};

export default ExceptionsManagementPortal;
